export class JiraEmployeeCredential {
    employeeName: string;
    jiraEmployeeId: string;

    constructor(employeeName: string, jiraEmployeeId: string) {
        this.employeeName = employeeName;
        this.jiraEmployeeId = jiraEmployeeId;
    }
}
